import { render, staticRenderFns } from "./survey-step-2.scene.vue?vue&type=template&id=f5b70a4e"
import script from "./survey-step-2.scene.ts?vue&type=script&lang=ts&external"
export * from "./survey-step-2.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./survey-step-2.scene.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports